import React from "react";

import { converDateToLocal } from '../../utils/commonUtilities';

export function showStaffVehicle (vehicleInfo,timeZone) { // USED IN eventDetails.js
    // vehicle_details: [{field_id: 1736235786584, field_type: 'string', text_value: 'StaffVeh555', date_value: null, field_name: 'Vehicle Number'}]
    if (!vehicleInfo?.vehicle_details?.length) return null;
    return (
        <div className='staff-veh-box text11 text-muted'>
            {vehicleInfo.vehicle_details.map((vData,vIndex)  => {
                return (<div key={vIndex}>
                    {vData.field_name ? vData.field_name+': ' : ''}
                    <b>{vData.field_type === 'string' ? vData.text_value : converDateToLocal(vData.date_value, timeZone.utc_offset, 'ddmmyyyy')}</b>
                </div>)
            }
            )}
        </div>
    )
}

export function showSelectedVehicle (vehicleInfo,timeZone) { // USED IN eventDetails.js
    // vehicle_details: [{id: 13, field_name: 'Vehicle Number', field_type: 'string', field_id: 1736235914369, text_value: 'AfltVeh1111', date_value: null, field_info: 27, is_active: true}]
    if (!vehicleInfo?.length) return null; 
    return (
        <>
        {vehicleInfo.map((vehInfo,vehInfoIndex)=>{
            return(<p key={vehInfoIndex} className="paddingTop0 paddingBottomp0">
                {vehInfo.field_name? vehInfo.field_name+': ':''} <b>{vehInfo.text_value ? vehInfo.text_value : vehInfo.date_value ? converDateToLocal(vehInfo.date_value,timeZone.utc_offset,'ddmmyyyy'):''}</b>
            </p>)
        })}
        </>
    )
}

